var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Trash_Full"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 7.5V12.75M7.5 7.5V12.75M4.5 4.5V13.35C4.5 14.1901 4.5 14.6098 4.66349 14.9307C4.8073 15.2129 5.0366 15.4429 5.31885 15.5867C5.6394 15.75 6.05925 15.75 6.89768 15.75H11.1023C11.9408 15.75 12.36 15.75 12.6805 15.5867C12.9628 15.4429 13.1929 15.2129 13.3367 14.9307C13.5 14.6101 13.5 14.1908 13.5 13.3523V4.5M4.5 4.5H6M4.5 4.5H3M6 4.5H12M6 4.5C6 3.80109 6 3.4518 6.11418 3.17615C6.26642 2.80861 6.55824 2.51642 6.92578 2.36418C7.20144 2.25 7.55109 2.25 8.25 2.25H9.75C10.4489 2.25 10.7984 2.25 11.074 2.36418C11.4416 2.51642 11.7335 2.80861 11.8857 3.17615C11.9999 3.4518 12 3.80109 12 4.5M12 4.5H13.5M13.5 4.5H15",
    stroke: "#5E42E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideDelete);
export default __webpack_public_path__ + "static/media/ic_guide_delete.4a106216d382728c5d04582214b79219.svg";
export { ForwardRef as ReactComponent };